import { reqMarkdown } from "../../lib/interface";

const getCodeExampleBlock = (codeType: string, code: string) => {
  return `
<div className="inlinecode-wrapper">
<div className="tip1">
<i class="fa fa-check-circle" className="icon"></i>
<span className="content2"> ${codeType} </span>
</div>
<code class="inlinecode-${codeType.toLowerCase()}">${code}</code>
</div>
`
};

const getMarkdownReq = ({
  type,
  name,
  name3,
  title,
  desc,
  params,
  successResponse,
  successResponseDesc,
  errorResponses,
}: reqMarkdown) => {
  if (type === 'get') {
    return `
<div className="getrequest">
<div className="row1">
<span className="gettag">
${type.toUpperCase()}
</span>
<div className="gettitle">
${name3}
</div>
</div>
<div className="divider1"></div>
<div className="reqcontent">
${title}
</div>
<p className="subcontent">
${desc}
</p>
<div className="divider2"></div>
<div className="gettitle">
Parameters
</div>
<div className="divider2"></div>
<div className="gettitle2">
Body
</div>
<div className="divider1"></div>
<div className="getparams">
${params.length == 0 ?
`<div className="getparamrow">
<span className="getparamcontent">
None
</span>
</div>`
: params.map((value, _index) => {
return (
`<div className="getparamrow">
<span className="getparamcontent">
${value.name}
</span>
<span className="getparamcontent">
${value.type}
</span>
<span className="getparamcontent">
${value.desc}
</span>
</div>`
)
})}
</div>
<div className="divider1"></div>
<div className="divider2"></div>
<div className="gettitle">
Responses
</div>
<div className="divider2"></div>
<div className="getresponses">
<div className="getresponserow">
<div>
<span className="getresponsecontent1">
●
</span>
<span className="getresponsecontent3">
200
</span>
</div>
<div>
<span className="getresponsecontent3">
${successResponseDesc}
</span>
</div>
</div>
<div className="inlinecode-wrapper">
${successResponse}
</div>
${errorResponses}
</div>
</div>
`;
  } else {
    return ``;
  }
}

export const getPageContent= (req: reqMarkdown) => {
  if (req.hasAdv) {
    return `
  <div className="mdrow" id=${req.id}>`
  +getMarkdownReq(req)
  +`
  <div className="mdcol">
    <div className="tip3">
      <i class="fa fa-info-circle" className="icon"></i>
      <span className="content2"> Public </span>
      <span className="endpoint2"> https://crunchtimeodds.com${req.name} </span>
    </div>
    <div className="tip3">
      <i class="fa fa-info-circle" className="icon"></i>
      <span className="content2"> Privileged </span>
      <span className="endpoint2"> https://crunchtimeodds.com${req.name2} </span>
    </div>
`+req.codeBlocks.map((cb,cbi) => {return cb})+
`
  </div>
  </div>
  `;
  } else {
  return `
  <div className="mdrow" id=${req.id}>`
  +getMarkdownReq(req)
  +`
  <div className="mdcol">
    <div className="tip3">
      <i class="fa fa-info-circle" className="icon"></i>
      <span className="content2"> Public </span>
      <span className="endpoint2"> https://crunchtimeodds.com${req.name} </span>
    </div>
`+req.codeBlocks.map((cb,cbi) => {return cb})+
`
  </div>
  </div>
  `;
  }
}

const error404 = `
<div className="getresponserow">
<div>
<span className="getresponsecontent2">
●
</span>
<span className="getresponsecontent3">
404
</span>
</div>
<div>
<span className="getresponsecontent3">
Not Found
</span>
</div>
</div>
<div className="divider2"></div>
`

const error401 = `
<div className="getresponserow">
<div>
<span className="getresponsecontent2">
●
</span>
<span className="getresponsecontent3">
401
</span>
</div>
<div>
<span className="getresponsecontent3">
Unauthorized
</span>
</div>
</div>
<div className="divider2"></div>
`

const error400 = `
<div className="getresponserow">
<div>
<span className="getresponsecontent2">
●
</span>
<span className="getresponsecontent3">
400
</span>
</div>
<div>
<span className="getresponsecontent3">
Bad Request
</span>
</div>
</div>
<div className="divider2"></div>
`

const error429 = `
<div className="getresponserow">
<div>
<span className="getresponsecontent2">
●
</span>
<span className="getresponsecontent3">
429
</span>
</div>
<div>
<span className="getresponsecontent3">
Too Many Requests
</span>
</div>
</div>
<div className="divider2"></div>
`

export const reqs: reqMarkdown[] = [
  {
    id: "health",
    type: "get",
    name: "/api/health",
    name2: "/api/health",
    name3: "/api/health",
    hasAdv: false,
    title: "Get API Health",
    desc: "Returns API health and version.",
    successResponse: `
<p className="getresponsecontent3">
<code class="inlinecode-bash">{
  "status": "ok",
  "version": "0.2.6"
}</code>
</p>
`,
    params: [],
    successResponseDesc: "Successful Response",
    errorResponses: error429,
    codeBlocks: [
      getCodeExampleBlock(
        "Python",
`import os
import requests
from dotenv import load_dotenv
load_dotenv()
API_KEY = os.getenv('API_KEY')
HEADERS = {'x-api-key': API_KEY, 'Content-Type': 'application/json'}
API_DOMAIN = 'https://www.crunchtimeodds.com'
HEALTH_ENDPOINT = f'{API_DOMAIN}/api/health'
resp = requests.get(HEALTH_ENDPOINT, headers=HEADERS)
print(resp.json())
`
      ),
    ]
  },
  {
    id: "teams",
    type: "get",
    name: "/api/v1/teams",
    name2: "/api/v1/teams",
    name3: "/api/v1/teams",
    hasAdv: false,
    title: "Get Teams",
    desc: "Returns teams available with the API.",
    successResponse: `
<p className="getresponsecontent3">
<code class="inlinecode-bash">[
  {
    "team_id": "mlb-Tampa-Bay-Rays",
    "nid": 10000449
  }
]</code>
</p>
`,
    params: [],
    successResponseDesc: "Successful Response",
    errorResponses: error401+error429,
    codeBlocks: [
      getCodeExampleBlock(
        "Python",
`import os
import requests
from dotenv import load_dotenv
load_dotenv()
API_KEY = os.getenv('API_KEY')
HEADERS = {'x-api-key': API_KEY, 'Content-Type': 'application/json'}
API_DOMAIN = 'https://www.crunchtimeodds.com'
TEAMS_ENDPOINT = f'{API_DOMAIN}/api/v1/teams'
resp = requests.get(TEAMS_ENDPOINT, headers=HEADERS)
teams = resp.json()
print(f"{len(teams)} teams found")
`
      ),
    ]
  },
  {
    id: "sites",
    type: "get",
    name: "/api/v1/sites",
    name2: "/api/v1/sites",
    name3: "/api/v1/sites",
    hasAdv: false,
    title: "Get Sites",
    desc: "Returns sites available with the API.",
    successResponse: `
<p className="getresponsecontent3">
<code class="inlinecode-bash">[
  {
    "site_id": "prophetx"
  }
]</code>
</p>
`,
    params: [],
    successResponseDesc: "Successful Response",
    errorResponses: error401+error429,
    codeBlocks: [
      getCodeExampleBlock(
        "Python",
`import os
import requests
from dotenv import load_dotenv
load_dotenv()
API_KEY = os.getenv('API_KEY')
HEADERS = {'x-api-key': API_KEY, 'Content-Type': 'application/json'}
API_DOMAIN = 'https://www.crunchtimeodds.com'
SITES_ENDPOINT = f'{API_DOMAIN}/api/v1/sites'
resp = requests.get(SITES_ENDPOINT, headers=HEADERS)
sites = resp.json()
print(f"{len(sites)} sites found")
`
      ),
    ]
  },
  {
    id: "positions",
    type: "get",
    name: "/api/v1/positions",
    name2: "/api/v1/positions",
    name3: "/api/v1/positions",
    hasAdv: false,
    title: "Get Positions",
    desc: "Returns positions available with the API.",
    successResponse: `
<p className="getresponsecontent3">
<code class="inlinecode-bash">[
  {
    "position_id": "mlb-pitcher-outs-over"
  }
]</code>
</p>
`,
    params: [],
    successResponseDesc: "Successful Response",
    errorResponses: error401+error429,
    codeBlocks: [
      getCodeExampleBlock(
        "Python",
`import os
import requests
from dotenv import load_dotenv
load_dotenv()
API_KEY = os.getenv('API_KEY')
HEADERS = {'x-api-key': API_KEY, 'Content-Type': 'application/json'}
API_DOMAIN = 'https://www.crunchtimeodds.com'
POSITIONS_ENDPOINT = f'{API_DOMAIN}/api/v1/positions'
resp = requests.get(POSITIONS_ENDPOINT, headers=HEADERS)
positions = resp.json()
print(f"{len(positions)} positions found")
`
      ),
    ]
  },
  {
    id: "game_ids",
    type: "get",
    name: "/api/v1/game_ids",
    name2: "/api/v1/game_ids",
    name3: "/api/v1/game_ids",
    //name2: "/api/v1/adv/games/ids",
    //name3: "/api/v1{/adv}/games/ids",
    //hasAdv: true,
    hasAdv: false,
    title: "Get Game IDs",
    desc: "Returns game ids available with the API.",
    successResponse: `
<p className="getresponsecontent3">
<code class="inlinecode-bash">[
  {
    "game_id": "mlb-TampaBayRays-StLouisCardinals-1755820800"
  }
]</code>
</p>
`,
    params: [
      {
        name: "page",
        type: "int (optional)",
        desc: "Page"
      },
    ],
    successResponseDesc: "Successful Response",
    errorResponses: error401+error429,
    codeBlocks: [
      getCodeExampleBlock(
        "Python",
`import os
import requests
from dotenv import load_dotenv
load_dotenv()
API_KEY = os.getenv('API_KEY')
HEADERS = {'x-api-key': API_KEY, 'Content-Type': 'application/json'}
API_DOMAIN = 'https://www.crunchtimeodds.com'
GAME_IDS_ENDPOINT = f'{API_ENDPOINT}/api/v1/game_ids'
game_ids = []
n_pages = 10
for page in range(0,n_pages):
  print(f"page = {page}")
  pg = page * 10
  resp = requests.get(
    f'{GAMEIDS_ENDPOINT}?page={pg}',
    headers=HEADERS
  )
  game_ids.extend(resp.json())
print(f"{len(game_ids)} game ids found in {n_pages} pages")
`
      ),
    ]
  },
  {
    id: "game",
    type: "get",
    name: "/api/v1/game",
    name2: "/api/v1/game",
    name3: "/api/v1/game",
    hasAdv: false,
    title: "Get Game",
    desc: "Returns game data based on game id.",
    successResponse: `
<p className="getresponsecontent3">
<code class="inlinecode-bash">{
  "game_id": "mlb-TampaBayRays-StLouisCardinals-1755820800",
  "league": "mlb",
  "t1_id": "mlb-Tampa-Bay-Rays",
  "t2_id": "mlb-St-Louis-Cardinals",
  "t1_score": 0,
  "t2_score": 0,
  "time": 1755820800,
  "t_time": 1755819300,
  "is_over": 1
}</code>
</p>
`,
    params: [
      {
        name: "game_id",
        type: "string (required)",
        desc: "Game ID"
      },
    ],
    successResponseDesc: "Successful Response",
    errorResponses: error400+error401+error404+error429,
    codeBlocks: [
      getCodeExampleBlock(
        "Python",
`""" example available at the CrunchtimeOdds Github """
`
      ),
    ]
  },
  {
    id: "markets",
    type: "get",
    name: "/api/v1/markets",
    name2: "/api/v1/markets",
    name3: "/api/v1/markets",
    hasAdv: false,
    title: "Get Markets",
    desc: "Returns market data based on game id, position, site, and/or page.",
    successResponse: `
<p className="getresponsecontent3">
<code class="inlinecode-bash">[
  {
    "site_id": "prophetx",
    "game_id": "mlb-TampaBayRays-StLouisCardinals-1755820800",
    "position_id": "mlb-pitcher-outs-over",
    "side": "sonny-gray",
    "odds": 1.9065420560747666,
    "line": 17.5,
    "updated_at": 1755797501
  }
]</code>
</p>
`,
    params: [
      {
        name: "game_id",
        type: "string (optional)",
        desc: "Game ID"
      },
      {
        name: "position_id",
        type: "string (optional)",
        desc: "Position ID"
      },
      {
        name: "site_id",
        type: "string (optional)",
        desc: "Site ID"
      },
      {
        name: "page",
        type: "int (optional)",
        desc: "Page"
      },
    ],
    successResponseDesc: "Successful Response",
    errorResponses: error401+error429,
    codeBlocks: [
      getCodeExampleBlock(
        "Python",
`""" example available at the CrunchtimeOdds Github """
`
      ),
    ]
  },
  {
    id: "markets_index",
    type: "get",
    name: "/api/v1/markets_index",
    name2: "/api/v1/markets_index",
    name3: "/api/v1/markets_index",
    hasAdv: false,
    title: "Get Indexed Markets",
    desc: "Returns indexed market data based on team, position, site, and/or page.",
    successResponse: `
<p className="getresponsecontent3">
<code class="inlinecode-bash">[
  {
    "site_id": "prophetx",
    "position_id": "mlb-run-line",
    "team_id": "mlb-Tampa-Bay-Rays",
    "opp_id": "mlb-New-York-Yankees",
    "unit_profit_7d": 0.2038,
    "unit_profit_30d": 0.2038,
    "unit_profit_90d": 0.2038,
    "unit_profit_1y": 0.2038,
    "unit_profit_all_time": 0.2038,
    "instances_7d": 4,
    "instances_30d": 4,
    "instances_90d": 4,
    "instances_1y": 4,
    "instances_all_time": 7
  }
]</code>
</p>
`,
    params: [
      {
        name: "team_id",
        type: "string (optional)",
        desc: "Team ID"
      },
      {
        name: "position_id",
        type: "string (optional)",
        desc: "Position ID"
      },
      {
        name: "site_id",
        type: "string (optional)",
        desc: "Site ID"
      },
      {
        name: "page",
        type: "int (optional)",
        desc: "Page"
      },
    ],
    successResponseDesc: "Successful Response",
    errorResponses: error401+error429,
    codeBlocks: [
      getCodeExampleBlock(
        "Python",
`""" example available at the CrunchtimeOdds Github """
`
      ),
    ]
  },
]